// Module
var code = "<template ess-loading.bind=\"state.loading\"> <div class=\"ess-wrap\"> <div class=\"col s12 m6\"> <ess-text value.bind=\"systemText\" label=\"${'cm:system.$' | t}\" class=\"ess-flex-item-fill\" required=\"true\" maxlength=\"50\"></ess-text> </div> </div> </template> ";
// Exports
module.exports = code;